import { on } from "@ngrx/store";
import { ContractAdminState } from "../contract-admin.state";
import { ContractManagementActions } from "./contract-management.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update contractAdmin state within PagesStore
// **************************************************************************

function withContractAdmin(state: PagesStore, updater: (contractAdmin: ContractAdminState) => ContractAdminState): PagesStore {
    return { ...state, contractAdmin: updater(state.contractAdmin) };
}

// **************************************************************************
// CONTRACT MANAGEMENT REDUCER (array format for PagesStore)
// Handles admin-specific loading states for contract CRUD operations
// **************************************************************************

const createContract = on(ContractManagementActions.createContract, (state: PagesStore) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    contractManagement: { ...contractAdminState.contractManagement, creating: true },
})));

const createContractSuccess = on(ContractManagementActions.createContractSuccess, (state: PagesStore) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    contractManagement: { ...contractAdminState.contractManagement, creating: false },
    error: null,
})));

const createContractFailure = on(ContractManagementActions.createContractFailure, (state: PagesStore, { error }) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    contractManagement: { ...contractAdminState.contractManagement, creating: false },
    error,
})));

const deleteContract = on(ContractManagementActions.deleteContract, (state: PagesStore) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    contractManagement: { ...contractAdminState.contractManagement, deleting: true },
})));

const deleteContractSuccess = on(ContractManagementActions.deleteContractSuccess, (state: PagesStore) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    contractManagement: { ...contractAdminState.contractManagement, deleting: false },
    error: null,
})));

const deleteContractFailure = on(ContractManagementActions.deleteContractFailure, (state: PagesStore, { error }) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    contractManagement: { ...contractAdminState.contractManagement, deleting: false },
    error,
})));

export const contractManagementReducer = [
    createContract,
    createContractSuccess,
    createContractFailure,
    deleteContract,
    deleteContractSuccess,
    deleteContractFailure,
];
